module.exports = __webpack_public_path__ + "img/wrong-icon.1d7c1d28.png";